export default "__VITE_ASSET__C37tPl0T__"